import { render, staticRenderFns } from "./chaperonage.vue?vue&type=template&id=28f207d5&scoped=true"
import script from "./chaperonage.vue?vue&type=script&lang=js"
export * from "./chaperonage.vue?vue&type=script&lang=js"
import style0 from "./chaperonage.vue?vue&type=style&index=0&id=28f207d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f207d5",
  null
  
)

export default component.exports